import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { useS4LContext } from '@s4l/react-context'
import React, { useEffect, useState } from 'react'

import styles from './index.module.css'
import PropertiesCarousel from '../PropertiesCarousel'
import { ListOfProperty } from '@s4l/stayforlong/property/domain/ListOfProperty'
import PropertyCard from '../PropertyCard'

interface IBannerPropertiesProps {
  /**
   * Id of the properties type banner from panel
   */
  bannerId: string

  /**
   * Number of days to add to the check-in date
   */
  checkInOffset?: number
}

function BannerProperties(props: IBannerPropertiesProps) {
  const { bannerId, checkInOffset = 0 } = props
  const [bannerProperties, setBannerProperties] = useState<ListOfProperty>(ListOfProperty.empty())
  const [loading, setLoading] = useState(false)

  const { domain } = useS4LContext()

  useEffect(() => {
    setLoading(true)
    if (!bannerId) return
    domain.GetListOfBannerPropertyUseCase.execute({ id: bannerId, checkInOffset })
      .then(([error, properties]) => {
        if (error) {
          console.error(error)
          return
        }
        if (!properties.isEmpty()) {
          setBannerProperties(properties)
        }
      })
      .finally(() => setLoading(false))
  }, [domain, bannerId, checkInOffset])

  if (!bannerId) return null

  return (
    <div className={styles.bannerProperties}>
      {bannerProperties.isEmpty() && !loading && <div>{/* EMPTY STATE */}</div>}
      {bannerProperties.isEmpty() && loading && <PropertiesCarousel.Placeholder />}
      {!bannerProperties.isEmpty() && !loading && (
        <PropertiesCarousel
          propertiesJSON={bannerProperties.toJSON()}
          checkInOffset={checkInOffset}
        >
          {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
          {(_property, _index) => <PropertyCard.FooterPrice />}
        </PropertiesCarousel>
      )}
    </div>
  )
}

BannerProperties.displayName = 'BannerProperties'
export default withErrorBoundary(BannerProperties)
